export const types = {
    SET_MESSAGE: "SET_MESSAGE",
    DELETE_MESSAGE: "DELETE_MESSAGE",
}
